// Merged Content workspace — combines the former Content, Languages and
// Knowledge Base sidebar items into one tabbed hub.
import React from 'react';
import HubScreen from './HubScreen';
import SanaEditor from './SanaEditor';
import Featured from './Featured';
import Notices from './Notices';
import Languages from './Languages';
import KnowledgeBase from './KnowledgeBase';
import ReviewsModeration from './ReviewsModeration';

const TABS = [
  { id: 'sanaeditor',    label: 'Sana Editor',    Component: SanaEditor },
  { id: 'appcontent',    label: 'App Content',    Component: Featured },
  { id: 'notices',       label: 'Notices',        Component: Notices },
  { id: 'languages',     label: 'Languages',      Component: Languages },
  { id: 'knowledgebase', label: 'Knowledge Base', Component: KnowledgeBase },
  { id: 'reviews',       label: 'Reviews',        Component: ReviewsModeration },
];

export default function ContentWorkspace(props) {
  return <HubScreen tabs={TABS} passProps={props} title="Content" />;
}
